import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import {Slider} from "@mui/material";
import {alpha} from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        border: "solid 2px",
        borderRadius: 10,
        marginTop: 5,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main
    },
    canvasAreaBorder: {
        width: (props) => props.canvasWidth,
        height: (props) => props.canvasHeight,
        left: (props) => props.canvasLeft,
        top: (props) => props.canvasTop,
        position: "absolute",
        backgroundColor: "transparent",
        border: (props) => props.drawingMode ? `5px solid ${theme.palette.secondary.main}` : `2px solid ${theme.palette.secondary.main}`,
    },
    icon: {
        height: 30,
        width: 30,
        color: theme.palette.common.white
    },
    actionButton: {
        marginBottom: -15,
        marginTop: -10,
        textAlign: "center"
    },
    elementContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: "50%",
        marginLeft: 20,
        marginRight: 20
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

const VisibilityRangeSlider = withStyles((theme) => ({
    root: {
        height: 2
    },
    thumb: {
        height: 20,
        width: 3,
        backgroundColor: '#3F51B5',
    },
    active: {},
    valueLabel: {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
        color: theme.palette.common.white
    },
    track: {
        height: 5,
    },
    rail: {
        height: 2,
        opacity: 0.5,
    },
    mark: {
        height: 15,
        width: 1,
    },
    markActive: {
        opacity: 1,
        backgroundColor: 'currentColor',
    },
}))(Slider);

export {useStyles, VisibilityRangeSlider};
